// extracted by mini-css-extract-plugin
export var active = "_b3-7";
export var container = "_b3-0";
export var evenWidth = "_b3-4";
export var large = "_b3-5";
export var outlet = "_b3-8";
export var slide = "_b3-2";
export var small = "_b3-6";
export var tab = "_b3-3";
export var tabs = "_b3-1";